import {
  getWaxUpTypeSelection,
  ItemTypeEnum,
  WaxUpTypeEnum,
  WaxUpTypeSelectionEnum,
  type WaxUpType,
  type WaxUpTypeSelection,
} from "@jasper/client-models";
import type { UpdateProductArgs } from "@jasper/use-cases";

import type { ConfigurableProduct } from "./types";

export const WAX_UP_TYPE_SELECTIONS: WaxUpTypeSelection[] = [
  WaxUpTypeSelectionEnum.NUMERICAL,
  WaxUpTypeSelectionEnum.PHYSICAL,
  WaxUpTypeSelectionEnum.NUMERICAL_AND_PHYSICAL,
];

type WaxUpItemDraft = {
  tooth: number;
  type: typeof ItemTypeEnum.waxUp;
  waxUpType: WaxUpType;
};

export const buildWaxUpItems = ({
  teeth,
  waxUpType,
}: {
  teeth: number[];
  waxUpType: WaxUpTypeSelection;
}): WaxUpItemDraft[] => {
  const waxUpTypes: WaxUpType[] =
    waxUpType === WaxUpTypeSelectionEnum.NUMERICAL_AND_PHYSICAL
      ? [WaxUpTypeEnum.NUMERICAL, WaxUpTypeEnum.PHYSICAL]
      : [waxUpType];

  return waxUpTypes.flatMap(type =>
    teeth.map(tooth => ({ tooth, type: ItemTypeEnum.waxUp, waxUpType: type }))
  );
};

export const applyWaxUpTeethSelection = ({
  teeth,
  product,
}: {
  teeth: number[];
  product: ConfigurableProduct;
}): UpdateProductArgs => ({
  productId: product.id,
  teeth,
  items: buildWaxUpItems({
    teeth,
    waxUpType: getWaxUpTypeSelection(product.items) ?? WaxUpTypeEnum.NUMERICAL,
  }),
});
